import React from 'react';
 const TodoHeader = () => {
    return <h1 className="App-header display-5">Todo App</h1>;
}
export default TodoHeader;